import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/textracer.webp';
import screenshot_target from '../../../images/letterfunnel/jolandakooi.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Jolanda Kooi"
      firstname="Jolanda"
      companyname="tex.tracer"
      competition="TrusTrace en TextileGenesis"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/jolandakooi.js